<template>
  <div id="settings">

    <header class="inner-head border-transparent h-14">
      <div class="flex justify-between">
        <h2 class="sub-head-title">Assessment Configuration</h2>
      </div>

    </header>

    <div class="w-full h-10 ml-8">
        <p>
         Change and use custom assessment throughout the platform.
        </p>
      </div>

    <div class="assessmentconfig w-11/12 ml-4 flex">

      <div class="bg-white w-full pb-3 mb-10 ">

        <div class="px-4">

        <form
          id="form-criteria"
          v-on:submit.prevent="saveSettings()"
          ref="formPlanning"
        >

          <!-- Section -->
          <section>
            <div class="flex flex-wrap mb-8">
              <div class="w-full">
                <label class="form-label  text-gray-500" for="grid-title">
                  Use custom assessment
                </label>
                <button
                  type="button"
                  class="
                    mr-3
                    mb-2
                    rounded
                    p-2
                    px-6
                    cursor-pointer
                    hover:bg-gray-500 hover:bg-opacity-50 hover:text-action-blue
                    font-bold
                    icon
                    fa-check
                  "
                  v-bind:class="[
                    true === isAssessmentCustom
                      ? 'bg-action-blue bg-opacity-75 text-white'
                      : 'bg-gray-200 text-gray-600',
                  ]"
                  @click="isAssessmentCustom = true"
                >
                  Custom
                </button>

                <button
                  type="button"
                  class="
                    mr-3
                    mb-2
                    rounded
                    p-2
                    px-6
                    cursor-pointer
                    hover:bg-gray-500 hover:bg-opacity-50 hover:text-action-blue
                    font-bold
                    icon
                    fa-times
                  "
                  v-bind:class="[
                    false === isAssessmentCustom
                      ? 'bg-action-blue bg-opacity-75 text-white'
                      : 'bg-gray-200 text-gray-600',
                  ]"
                  @click="isAssessmentCustom = false"
                >
                  Off
                </button>
              </div>
            </div>
          </section>
        </form>

      


        <div class="w-full flex justify-end content-baseline space-x-10 text-right border-t">
          <div class="w-9/12 flex justify-end">

            <p v-if="hasCompleted" class="text-green-500 mt-4">
              Settings configuration saved.
            </p>
               
            <p v-if="errored" class="text-red-500 mt-4">
              We are not able to retrieve this information at the moment, please try
              back later.
            </p>

            <div
              style="text-align: center"
              class=""
              v-if="loading"
            >
              <i class="spinner fa fa-spinner fa-spin text-sm"></i>
              <p>Saving</p>
            </div>
          </div>

         <button
              @click="submitForm()"
              type="button"
              class="publish-button hover:opacity-75 mt-4"
            >
              Publish Changes
            </button>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { settingsMixin } from "@/mixins/settingsMixin.js";


export default {
  name: "assessmentconfig",
  mixins: [settingsMixin],
  props: {

  },
  computed: {
    ...mapGetters({ currentUser: "currentUser", access: "currentAccess" }),
   
  },
  watch: {
   
  },
  data() {
    return {

    };
  },
  created() {
  },
  mounted() {

  },
  methods: {
    submitForm() {
      if (this.$refs.formPlanning.requestSubmit === undefined) {
        this.saveSettings();
      } else {
        this.$refs.formPlanning.requestSubmit();
      }
    },

  },
  components: {
  },
};
</script>


<style scoped>

</style>

